export default "__VITE_ASSET__pPGSi3Lj__"